"use client";
import { usePageState } from "@/Context/PageState";
import style from "@/styles/ElevateForm.module.scss";
import { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import $ from "jquery";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Image from "next/image";

const ElevateForm = () => {
  const {
    register,
    trigger,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ mode: "all" });

  const submitBtn = useRef(null);

  const [isValidNum, setIsValidNum] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const { CommonSubmitForm, CommonValidateForm, getCountryCode, countryCode, onloadCallback } = usePageState();
  const effectRan = useRef(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const values = getValues();
    // Clean up the phone number before submission
    if (values.mobile && values.mobile.startsWith("0")) {
      values.mobile = values.mobile.substring(1);
    }
    values.mobile = values.mobile.replace(/[\(\)\-]/g, "");
    triggerValidation();

    if (CommonValidateForm(1) == true && isValidNum) {
      CommonSubmitForm(1, values);
      setPhoneNumber(""); // Reset phone number after submission
    } else {
      triggerValidation();
    }
  };

  const triggerValidation = () => {
    trigger(); // all fields
  };

  const onChange = (isValid, rawValue) => {
    const containsOnlyNumbers = /^\d+$/.test(rawValue);
    if (containsOnlyNumbers) {
      setIsValidNum(isValid);
      setPhoneNumber(rawValue);
      setValue("mobile", rawValue);
    } else {
      if (!rawValue) {
        setIsValidNum(isValid);
        setPhoneNumber(rawValue);
        setValue("mobile", rawValue);
      }
    }
  };

  useEffect(() => {
    getCountryCode();
    if (effectRan.current === false) {
      $(document).on("focus blur change", ".contact-form input, .contact-form textarea", function () {
        $(this).val($(this).val().replace(/^\s+/, ""));
      });

      return () => {
        effectRan.current = true;
      };
    }
  }, []);

  return (
    <section className={`${style["contactusformmaindiv"]}`}>
      <div className="container">
        <div className={`${style["contactformbody"]}`}>
          <div className={`${style["left"]}`}>
            <div className={`${style["lefttop"]} ${style["bgcard"]}  ${style["contentpart"]}`}>
              <h2 className={`${style["title"]}`}> Transform Your Vision into Reality – Let’s Digitize Your Future!</h2>
              <p className={`${style["description"]}`}>
                Take the First Step Toward Smarter Management! Please submit your details, and our experts will guide
                you in detail
              </p>
              <div className={`${style["featureslistdiv"]}`}>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/icons/check_image.png" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Customizable Learning Modules</p>
                </div>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/icons/check_image.png" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Real-Time Analytics</p>
                </div>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/icons/check_image.png" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Seamless User Experience</p>
                </div>
              </div>

              <h4 className={`${style["contactlineshading"]}`}>Contact By Us</h4>
              <div className={`${style["contactlinesdiv"]}`}>
                <div className={`${style["flexitem"]}`}>
                  <div className={`${style["contactlinerow"]}`}>
                    <Image
                      className={`${style["imagebox"]}`}
                      src="/images/icons/contact_email_ic.svg"
                      alt="contact"
                      width={0}
                      height={0}
                    />

                    <div className={`${style["contenbox"]}`}>
                      <a className={`${style["contactlink"]}`} href="mailto:marketing@sapphiresolutions.net">
                        marketing@sapphiresolutions.net
                      </a>
                    </div>
                  </div>
                  {/* <div className={`${style["contactlinerow"]}`}>
                    <Image
                      className={`${style["imagebox"]}`}
                      src="/images/icons/contact_us_phone_ic.svg"
                      alt="contact"
                      width={0}
                      height={0}
                    />
                    <div className={`${style["contenbox"]}`}>
                      <a className={`${style["contactlink"]}`} href="tel:+919726748800">
                        +919726748800
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
              <h4 className={`${style["contactlineshading2"]}`}>Sales & Marketing</h4>
              <div className={`${style["contactlinesdiv"]}`}>
                <div className={`${style["flexitem"]}`}>
                  <div className={`${style["contactlinerow"]}`}>
                    <Image
                      className={`${style["imagebox"]}`}
                      src="/images/icons/contact_us_phone_ic.svg"
                      alt="contact"
                      width={0}
                      height={0}
                    />
                    <div className={`${style["contenbox"]}`}>
                      <a className={`${style["contactlink"]}`} href="tel:+91-942-644-2424">
                      +91-942-644-2424
                      </a>
                    </div>
                  </div>
                  <div className={`${style["contactlinerow"]}`}>
                    <Image
                      className={`${style["imagebox"]}`}
                      src="/images/icons/contact_us_phone_ic.svg"
                      alt="contact"
                      width={0}
                      height={0}
                    />
                    <div className={`${style["contenbox"]}`}>
                      <a className={`${style["contactlink"]}`} href="tel:+91-972-674-8800">
                      +91-972-674-8800
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className={`${style["leftbottom"]} ${style["bgcard"]}`}>
              <p className={`${style["description"]}`}>
                We are all here to listen to any doubt, query, clarification, anything from you. Just get connected with
                us and we will get back to you as soon as possible!
              </p>
              <div className={`${style["featureslistdiv"]}`}>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/contact_us/reducecoast.svg" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Cost-effective</p>
                </div>
                <div className={`${style["featureline"]}`}>
                  <div className={`${style["icondiv"]}`}>
                    <Image src="/images/contact_us/scalesupport.svg" alt="contact" width={0} height={0} />
                  </div>
                  <p className={`${style["featurename"]}`}>Reliable Support</p>
                </div>
              </div>
            </div> */}
          </div>
          <div className={`${style["right"]} ${style["bgcard"]}  ${style["bgcardpattrent"]} `}>
            <form
              id="contact-form"
              method="post"
              encType="multipart/form-data"
              autoComplete="off"
              className={`${style["formmain"]} commonformclass contact-form commonform`}
            >
              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                {/* <label className={`${style["inputlable"]}`}>Your Name*</label> */}
                <div className={`${style["inputdiv"]}`}>
                  <input
                    className={`${style["input"]}`}
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    {...register("name", {
                      required: "Name is required",
                      pattern: {
                        value: /\p{L}/gu,
                        message: "At least one alphabet character is required",
                      },
                    })}
                  />
                </div>
                <div id="name_error" className={`${style["error"]}`}>
                  {errors.name?.message}
                </div>
              </div>

              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                {/* <label className={`${style["inputlable"]}`}>Your Email*</label> */}
                <div className={`${style["inputdiv"]}`}>
                  <input
                    className={`${style["input"]}`}
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i,
                        message: "Email is not valid",
                      },
                    })}
                  />
                </div>
                <div id="email_error" className={`${style["error"]}`}>
                  {errors.email?.message}
                </div>
              </div>
              <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                {/* <label htmlFor="mobile_contact" className={`${style["inputlable"]}`}>
                  Mobile Number*
                </label> */}
                <div className={`${style["inputdiv"]} ${style["w-100"]}`}>
                  {/* hidden input */}
                  <input
                    {...register("mobile")}
                    type="hidden"
                    className={style["hidden"]}
                    id="contact_us_mobile_number"
                    value={phoneNumber}
                    name="mobile"
                  />
                  {/* hidden input */}
                  {countryCode && (
                    <IntlTelInput
                      // type="tel"
                      numberType={"MOBILE"}
                      id="mobile_contact"
                      preferredCountries={["us","gb","in"]}
                      autoPlaceholder="false"
                      inputClassName={`contact-us-phone ${style["input"]} `}
                      // initialCountry="auto"
                      value={phoneNumber}
                      defaultCountry={countryCode}
                      // autoCountryLoaded
                      // geoIpLookup={true}
                      onPhoneNumberChange={onChange}
                      onPhoneNumberBlur={onChange}
                      // format
                      // telInputProps={isValidNumber}
                    />
                  )}
                  <div id="mobile-emsg" className={`${style["error"]}`}>
                    {!isValidNum && "Please enter valid phone number"}
                  </div>
                </div>
                {errors.country && <span className={`${style["error"]}`}>{errors.country.join(", ")}</span>}
              </div>
              <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                {/* <label className={`${style["inputlable"]}`}>Company*</label> */}
                <div className={`${style["inputdiv"]}`}>
                  <input
                    className={`${style["input"]}`}
                    type="text"
                    name="organization"
                    placeholder="School Name"
                    {...register("organization", {
                      required: "Company is required",
                      pattern: {
                        value: /\p{L}/gu,
                        message: "At least one alphabet character is required",
                      },
                    })}
                  />
                </div>
                <div id="company_error" className={`${style["error"]}`}>
                  {errors.organization?.message}
                </div>
              </div>

              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                {/* <label className={`${style["inputlable"]}`}>Message*</label> */}
                <div className={`${style["inputdiv"]}`}>
                  <textarea
                    className={`${style["input"]} alphabetcheck`}
                    id="message_contact"
                    type="text"
                    row={15}
                    name="message"
                    placeholder="Write your message"
                    {...register("message", {
                      required: "Message is required",
                      pattern: {
                        value: /\p{L}/gu,
                        message: "At least one alphabet character is required",
                      },
                    })}
                  ></textarea>
                </div>
                <div className={`${style["error"]}`}>{errors.message?.message}</div>
              </div>

              {/* Add other form fields here */}
              <div className={`${style["formbottompart"]}`}>
                <button
                  ref={submitBtn}
                  className={`${style["buttonsubmit"]} commonformbtn`}
                  type="submit"
                  onClick={onSubmit}
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ElevateForm;
